<template>
  <section :id="data?.anchor_id ? data.anchor_id : null" class="imageGallery container" :class="{'singleImage': mainImages?.length === 1, 'withoutImages': !mainImages?.length}">
    <template v-for="item in mainImages">
      <div class="imageGallery__Image" :class="{'imageGallery__Image--Overlay': item.is_overlay}">
        <FlarePicture
          v-if="item.image"
          :src="{
            1920: { src: item.image, width: 800, height: 660, size: 'both', crop: 'fill' },
          }"
          :alt="item.image.alt"
        />
        <div class="imageGallery__ImageText" v-if="item.is_overlay && item.overlay_text">
          <p>{{ item.overlay_text }}</p>
        </div>
      </div>
    </template>
    
    <div class="imageGallery__Text">
      <h2 v-text="data.title" />
      <p v-text="data.lead" />
      <Button secondary medium @click="open('gallery')">
        <template #prepend>
          <Icon name="photo-gallery" />
        </template>
        {{ $t('seeGallery') }}
      </Button>
    </div>
  </section>

  <Modal v-show="dialogs.gallery" v-model="dialogs.gallery" class="modal__Gallery">
    <template v-for="item in activeAccommodationGallery" :key="item?.id">
      <div class="modal__GalleryImage" :class="{'modal__GalleryImage--Overlay': item.is_overlay}">
        <FlarePicture v-if="item.image"
          :src="{
            1920: { src: item.image || item, width: 1000 },
          }"
          :alt="item.image?.alt || item.alt"
        />
        <div class="imageGallery__ImageText" v-if="item.is_overlay && item.overlay_text">
          <p>{{ item.overlay_text }}</p>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup>
  const props = defineProps({
    data: {}
  });

  const { accommodationsData } = useSetup();
  const { page } = usePage();
  const dialogs = reactive({
    gallery: false
  });
  const { open } = useModal(dialogs);

  const mainImages = computed(() => props.data.gallery_overlay.slice(0, 3));
  const activeAccommodationGallery = computed(() => accommodationsData.value?.[page?.value?.id]?.gallery || []);
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_imageGallery.scss');
</style>